import {h, Fragment} from "preact"
import { useResponse, AutocompleteElement, Keywords, useCurrencyFormatting } from "@nosto/preact"
import { productImagePlaceholder } from "../helpers"
import SubmitButton from "./elements/SubmitButton"
import { useState } from "preact/hooks"

export default function Autocomplete() {
    const { products, keywords } = useResponse()
    const { format } = useCurrencyFormatting()
    const [altImg, setAltImg] = useState()

    if (!products?.hits?.length && !keywords?.hits?.length) {
        return
    }

    return (
        <div
            class="ns-autocomplete ns-absolute ns-d-flex ns-flex-column ns-flex-sm-row ns-align-items-start ns-background-white"
            data-nosto-element="autocomplete"
        >
            <div class="wrapper">
                <div class="ns-d-flex ns-flex-column ns-flex-sm-row ns-autocomplete-wrapper">
                    {keywords?.hits?.length > 0 && (
                        <div
                            class={`ns-autocomplete-keywords ns-d-flex ns-flex-column ns-col-12 ${
                                products?.hits?.length > 0 ? "ns-col-sm-4" : "ns-col-sm-12"
                            }`}
                        >
                            <div class="ns-autocomplete-header">
                                Recommended Searches
                            </div>
                            <div class="ns-d-flex ns-flex-column">
                                <Keywords
                                    hits={keywords.hits}
                                    keywordComponent={Keyword}
                                    elementComponent={Element}
                                    keywordInCategoryComponent={KeywordInCategory}
                                />
                            </div>
                            {!products?.hits?.length && <SubmitButton text="See all search results" />}
                        </div>
                    )}
                    {products?.hits?.length > 0 && (
                        <div class="ns-autocomplete-products ns-d-flex ns-flex-column ns-flex-grow-1">
                            <div class="ns-autocomplete-header">
                                Recommended Products
                            </div>
                            <div class="grid">
                                {products?.hits?.map(hit => {
                                    var prodStyle = hit.customFields?.find(v => v.key === 'custom_fields-style')?.value
                                    return (
                                        <AutocompleteElement hit={hit}>
                                            <div
                                                data-url={hit.url}
                                                class="ns-autocomplete-product product-item grid-item product-item--centered product-item--outer-text"
                                                data-nosto-element="product"
                                            >
                                                <div class="product-item__image double__image">
                                                    <div class="product-item__bg" data-product-image-default="">
                                                        <figure
                                                        class="image-wrapper image-wrapper--cover lazy-image lazy-image--backfill aos-animate"
                                                        style="--aspect-ratio: 0.6666666666666666"
                                                        data-aos="img-in"
                                                        data-aos-delay="0"
                                                        data-aos-duration="800"
                                                        data-aos-anchor={`#product-item--template--nosto-${hit.productId}`}
                                                        data-aos-easing="ease-out-quart"
                                                        >
                                                            <img
                                                                src={hit.imageUrl.replace(".jpg", "_900x.jpg")}
                                                                alt=""
                                                                width="853"
                                                                height="1279"
                                                                loading="eager"
                                                                srcset={`
                                                                ${(hit.imageUrl).replace(".jpg", "_180x.jpg")} 180w,
                                                                ${hit.imageUrl.replace(".jpg", "_320x.jpg")} 360w,
                                                                ${hit.imageUrl.replace(".jpg", "_540x.jpg")} 540w,
                                                                ${hit.imageUrl.replace(".jpg", "_720x.jpg")} 720w,
                                                                ${hit.imageUrl.replace(".jpg", "_900x.jpg")} 900w,
                                                                ${hit.imageUrl.replace(".jpg", "_1080x.jpg")} 1080w,
                                                                ${hit.imageUrl.replace(".jpg", "_1296x.jpg")} 1296w
                                                                `}
                                                                sizes="(min-width: 1400px) calc((100vw - 288px - 100px) / 4 - 32px), (min-width: 750px) calc((100vw - 258px - 64px) / 2 - 32px), (min-width: 480px) calc((100vw - 32px) / 2), calc((100vw - 32px) / 2)"
                                                                fetchpriority="high"
                                                                class="fit-cover"
                                                            />
                                                        </figure>
                                                    </div>
                                                    {hit.alternateImageUrls && hit.alternateImageUrls?.length != 0 &&
                                                    <div class="product-item__bg__under">
                                                        <figure class="image-wrapper image-wrapper--cover lazy-image lazy-image--backfill" style="--aspect-ratio: 0.6666666666666666">
                                                            <img
                                                                src={hit.alternateImageUrls[0]?.replace(".jpg", "_900x.jpg")}
                                                                alt=""
                                                                width="853"
                                                                height="1279"
                                                                loading="lazy"
                                                                srcset={`
                                                                  ${hit.alternateImageUrls[0].replace(".jpg", "_180x.jpg")} 180w,
                                                                  ${hit.alternateImageUrls[0].replace(".jpg", "_360x.jpg")} 360w,
                                                                  ${hit.alternateImageUrls[0].replace(".jpg", "_540x.jpg")} 540w,
                                                                  ${hit.alternateImageUrls[0].replace(".jpg", "_720x.jpg")}720w,
                                                                  ${hit.alternateImageUrls[0].replace(".jpg", "_900x.jpg")} 900w,
                                                                  ${hit.alternateImageUrls[0].replace(".jpg", "_1080x.jpg")} 1080w,
                                                                  ${hit.alternateImageUrls[0].replace(".jpg", "_1296x.jpg")} 1296w 
                                                                `}
                                                                sizes="(min-width: 1400px) calc((100vw - 288px - 100px) / 4 - 32px), (min-width: 750px) calc((100vw - 258px - 64px) / 2 - 32px), (min-width: 480px) calc((100vw - 32px) / 2), calc((100vw - 32px) / 2)"
                                                                class="fit-cover"
                                                            />
                                                        </figure>
                                                    </div>}
                                                </div>
                                                <div class="product-information">
                                                    <div class="product-item__info">
                                                        <div class="product-item__title">{prodStyle}</div>
                                                        {hit.listPrice && hit.listPrice > hit.price ? (
                                                            <span class="price sale">
                                                                <span class="new-price">{format(hit.price)}</span>
                                                                <span class="old-price">{format(hit.listPrice)}</span>
                                                            </span>
                                                        ) : (
                                                            <span class="price">
                                                                <span class="new-price">{format(hit.price)}</span>
                                                            </span>
                                                        )
                                                        }
                                                    </div> 
                                                </div>
                                            </div>
                                        </AutocompleteElement>
                                    )
                                })}
                            </div>
                            <SubmitButton text="View all results" />
                        </div>
                    )}
                </div>
            </div>
        </div>
    )
}

function Keyword({ hit }) {
    return (
        <span data-nosto-element="keyword">
            {hit?._highlight?.keyword ? (
                <span
                    dangerouslySetInnerHTML={{
                        __html: hit._highlight.keyword
                    }}
                ></span>
            ) : (
                hit.keyword
            )}
        </span>
    )
}

function Element({ hit, keywordComponent, filter }) {
    return (
        <AutocompleteElement hit={hit} filter={filter} class="predictive-search__item">
            {keywordComponent}
        </AutocompleteElement>
    )
}

function KeywordInCategory({ category, children }) {
    return (
        <span class="ns-clickable">
            {category?.value ? (
                <span>
                    {children}{" "}
                    <span class="ns-keyword-in-category">
                        in <span>{category.value}</span>
                    </span>
                </span>
            ) : (
                children
            )}
        </span>
    )
}
